<mat-icon [ngClass]="{'warning': isWarning}" class="tooltip clickable" [matTooltip]="tooltip" (click)="openDialog()" [svgIcon]="isWarning ? 'error' : 'help'"></mat-icon>
